import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { setLoading } from 'features/auth/chatSlice';
import { useEffect } from 'react';
import Media from 'react-media';
import { useDispatch } from 'react-redux';
import { fetchInboxUsers } from 'utils/Firebase.util';
import Profile from 'views/DesktopViews/ProfilePage';
import MobileProfile from 'views/MobileViews/ProfilePage';

const MainProfile = () => {
  const dispatch = useDispatch();
  const authState = useAppSelector(selectAuth);
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        await fetchInboxUsers(authState, dispatch, setLoading);
      } catch (error) {
        console.log(error);
      }
    };
    fetchUsers();
    //eslint-disable-next-line
  }, [authState.id]);
  return (
    <Media query="(max-width: 850px)">
      {matches => (matches ? <MobileProfile /> : <Profile />)}
    </Media>
  );
};

export default MainProfile;
